import { FC, IframeHTMLAttributes } from "react";
import clsx from "clsx";

import TallyIframe from "@/components/tally-forms/TallyIframe";

// -----------------------------------------------------------------------

export type ISecurityIframeSectionProps =
  IframeHTMLAttributes<HTMLIFrameElement> & {
    url?: string;
  };

const SecurityIframeSection: FC<ISecurityIframeSectionProps> = (props) => {
  const { url, className, ...other } = props;

  return (
    <div className={clsx("pb-5 lg:pb-8 xl:pb-[50px]", className)} {...other}>
      {url && (
        <div className="w-full bg-secondary-50">
          <div className="container px-5 pb-2.5 pt-5 md:px-14 lg:px-24 lg:pb-6 lg:pt-8 xl:px-[135px]">
            <TallyIframe url={url} className="w-full" />
          </div>
        </div>
      )}
    </div>
  );
};

export default SecurityIframeSection;
